import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dce65644"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer py-3 mt-4 d-flex align-items-center bg-sand" }
const _hoisted_2 = { class: "container container--large footer-inner" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-sm-6" }
const _hoisted_5 = { class: "p-0 list-unstyled mb-0 d-sm-flex flex-column flex-sm-row text-nowrap" }
const _hoisted_6 = { class: "mb-1 mb-sm-0" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Impressum")
const _hoisted_8 = { class: "mb-1 mb-sm-0" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Datenschutz")
const _hoisted_10 = { class: "mb-1 mb-sm-0" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Kontakt")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-1 mb-sm-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-decoration-none link-dark fw-medium",
    type: "button",
    "data-bs-toggle": "modal",
    "data-bs-target": "#test-system-info"
  }, " Infos zum Testsystem ")
], -1))
const _hoisted_13 = { class: "col-12 col-sm-6 text-start text-sm-end" }
const _hoisted_14 = { class: "m-0 text-dark opacity-50" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "m-0 text-dark opacity-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/impressum",
                class: "text-decoration-none link-dark fw-medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/datenschutz",
                class: "text-decoration-none link-dark fw-medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/kontakt",
                class: "text-decoration-none link-dark fw-medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("small", _hoisted_14, "© " + _toDisplayString(_ctx.year) + " Pilot Natapp", 1),
          _hoisted_15,
          _createElementVNode("small", _hoisted_16, "Version: " + _toDisplayString(_ctx.version), 1)
        ])
      ])
    ])
  ]))
}